document.addEventListener("DOMContentLoaded", function () {
  // Select various elements needed for functionality
  const totalPriceElement = document.getElementById("totalPrice"); // Element to display the total price
  const summaryContent = document.getElementById("summaryContent"); // Element to display the summary of selected items
  const tabContent = document.querySelectorAll(".tab-content"); // All tab content sections
  const tabButton = document.querySelectorAll(".tab-button"); // All tab buttons
  const ampInputQuantity = document.querySelectorAll(".amp-input-quantity"); // All quantity input fields in the amplifier section
  const quantityInputs = document.querySelectorAll("input[type='number']");

  quantityInputs.forEach((input) => {
    input.addEventListener("input", (e) => {
      if (input.value === "") {
        input.value = 0;
      }
    });
  });

  // Iterate over each quantity input and add an event listener
  ampInputQuantity.forEach((input) => {
    input.addEventListener("input", (e) => {
      const maxVal = parseInt(input.getAttribute("max")) || 4; // Set default max to 4
      if (parseInt(input.value) > maxVal) {
        input.value = maxVal; // Reset value to max if exceeded
      }

      const inputArr = Array.from(ampInputQuantity); // Convert NodeList to array
      const currentInput = e.target; // Current input that triggered the event

      // Check if any input has a value greater than 0
      const isAnyGreaterThanZero = inputArr.some(
        (input) => parseInt(input.value) > 0
      );

      const amplifierItems = document.querySelectorAll(".amplifier-item"); // All amplifier items

      if (isAnyGreaterThanZero) {
        // If any input has a value greater than 0, disable all other inputs and their cards
        inputArr.forEach((input, index) => {
          if (input !== currentInput) {
            amplifierItems[index].classList.add("disabled"); // Disable the whole card
            input.disabled = true; // Disable the input
          }
        });
      } else {
        // If no inputs have a value greater than 0, re-enable all inputs and their cards
        inputArr.forEach((input, index) => {
          amplifierItems[index].classList.remove("disabled");
          input.disabled = false;
        });
      }
    });
  });

  // Add click event listeners to each tab button to handle tab switching
  tabButton.forEach((button, index) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      // Remove 'active' class from all tab contents and reset inputs of inactive tabs
      tabContent.forEach((content) => {
        content.classList.remove("active");
      });

      tabButton.forEach((btn) => {
        btn.classList.remove("selected");
      });

      e.target.classList.add("selected"); // Highlight the selected tab button

      // Show the content of the clicked tab
      tabContent[index].classList.add("active");
    });
  });

  // Shared function to handle changes in quantity input fields
  function handleQuantityChange(input) {
    tabButton.forEach((button, index) => {
      button.classList.remove("active"); // Deselect all tabs
    });

    let number = input.value;
    for (let i = 0; i < number; i++) {
      tabButton[i].classList.add("active"); // Activate tabs up to the quantity value
    }

    if (tabButton[0].classList.contains("active")) {
      tabContent[0].classList.add("active");
    }

    tabButton.forEach((button, index) => {
      if (!button.classList.contains("active")) {
        setToZero(tabContent[index], index); // Reset inactive tabs to 0
        tabContent[index].classList.remove("active");
        button.classList.remove("selected");
      }
    });

    updateTotalPrice(); // Update the price whenever quantity changes
  }

  // Attach the handleQuantityChange function to each amplifier quantity input field
  ampInputQuantity.forEach((input) => {
    input.addEventListener("input", (e) => {
      handleQuantityChange(e.target);
    });
  });

  // Function to reset all inputs and items within a tab to zero
  function setToZero(content, index) {
    const contentInput = content.querySelectorAll("input");
    const tabItems = content.querySelectorAll(".product-item");

    // Re-enable all product items
    tabItems.forEach((product) => {
      product.classList.remove("disabled");
    });

    // Set all input fields to zero and make them visible
    contentInput.forEach((product) => {
      product.value = 0;
      product.classList.remove("hide");
    });
  }

  // Function to apply quantity selection logic within a specific tab
  function applyQuantityLogicToTab(tabContent) {
    const productQuantityInputs = tabContent.querySelectorAll(
      "input[type='number']"
    );
    const tabItems = tabContent.querySelectorAll(".product-item");
    let quantities = Array(tabItems.length).fill(0); // Initialize array to track selected quantities

    // Add input event listener to each quantity input field
    productQuantityInputs.forEach((input, inputIndex) => {
      input.addEventListener("input", () => {
        const maxVal = parseInt(input.getAttribute("max")) || 2; // Set default max to 2
        if (parseInt(input.value) > maxVal) {
          input.value = maxVal; // Reset value to max if exceeded
        }

        const value = parseInt(input.value) || 0; // Get the input value or set to 0 if invalid
        quantities[inputIndex] = value; // Update the quantities array with the current value

        const totalQuantity = quantities.reduce((acc, curr) => acc + curr, 0); // Calculate the total quantity selected
        const areTwoItemsSelected =
          quantities.filter((val) => val === 1).length === 2; // Check if two items are selected with a quantity of 1 each
        const isSingleItemSelected = quantities.includes(2); // Check if any single item has a quantity of 2

        // Update max quantity limits and enable/disable inputs based on current selections
        productQuantityInputs.forEach((input, idx) => {
          if (isSingleItemSelected || areTwoItemsSelected) {
            if (quantities[idx] === 0) {
              input.setAttribute("max", "0"); // Set max to 0 for other inputs if the current max is reached
            } else if (quantities[idx] === 1 && !isSingleItemSelected) {
              input.setAttribute("max", "1"); // Allow a max of 1 for the second item
            } else {
              input.setAttribute("max", "2");
            }
          } else {
            input.setAttribute("max", "2"); // Allow a max of 2 if no other constraints apply
          }
        });

        // Disable items that are not selected when the total quantity is 2
        tabItems.forEach((item, idx) => {
          if (totalQuantity >= 2 && quantities[idx] === 0) {
            item.classList.add("disabled");
          } else {
            item.classList.remove("disabled");
          }
        });

        updateTotalPrice(); // Update the total price whenever quantities change
      });
    });
  }

  // Apply the quantity selection logic to each tab content section
  tabContent.forEach((content) => {
    applyQuantityLogicToTab(content);
  });

  // Function to update the total price and summary section
  function updateTotalPrice() {
    let total = 0;
    let summaryHtml = "";

    // Iterate over each product item to calculate total price
    document.querySelectorAll(".product-item").forEach((item) => {
      const quantityInput = item.querySelector('input[name^="quantity_"]'); // Quantity input
      const variantSelect = item.querySelector('select[name^="variant_"]'); // Variant select input (if any)
      const priceElement = item.querySelector(".product-price"); // Element showing the base price
      const basePriceCents =
        parseFloat(priceElement.getAttribute("data-price")) * 100; // Convert base price to cents
      let variantPriceCents = basePriceCents;

      if (parseInt(quantityInput.value) > 0) {
        item.style.border = "1px solid #157dc3";
      } else {
        item.style.border = "1px solid #efefef";
      }

      if (quantityInput && quantityInput.value > 0) {
        const quantity = parseInt(quantityInput.value, 10); // Get the selected quantity
        const variantId = variantSelect
          ? variantSelect.value
          : item.querySelector('input[name^="variant_"]').value; // Get the variant ID if present

        let variantName = ""; // Initialize the variant name

        if (variantSelect) {
          variantPriceCents = parseFloat(
            variantSelect.options[variantSelect.selectedIndex].getAttribute(
              "data-price"
            )
          );
          variantName =
            variantSelect.options[
              variantSelect.selectedIndex
            ].textContent.split(" - ")[0]; // Get the variant name
        }

        const itemTotalCents = variantPriceCents * quantity; // Calculate total price for the item
        const itemTotal = itemTotalCents / 100; // Convert cents back to dollars
        total += itemTotal; // Add to the running total

        const productTitle = item.querySelector("h3").textContent;

        // Add item details to the summary, including variant name if it exists
        summaryHtml += `<p><strong>${quantity} x |</strong> ${productTitle} <strong>${
          variantName ? `<strong> (${variantName} ) </strong>` : ""
        }</strong>= <strong>£${itemTotal.toFixed(2)}</strong></p>`;
      }
    });

    // Update the summary content and total price displayed on the page
    summaryContent.innerHTML = summaryHtml || "<p>No items selected.</p>";
    totalPriceElement.textContent = `Total: £${total.toFixed(2)} (incl. VAT)`;
  }

  // Attach event listeners to all quantity and variant select inputs to update the price on change
  document
    .querySelectorAll('input[name^="quantity_"], select[name^="variant_"]')
    .forEach((element) => {
      element.addEventListener("change", updateTotalPrice);
    });

  // Perform an initial calculation of the total price on page load
  updateTotalPrice();

  // Handle the Add to Cart button click
  document
    .getElementById("addToCartBtn")
    .addEventListener("click", function () {
      const form = document.getElementById("bundle-order-form"); // The form containing all the product selections
      const formData = new FormData(form); // FormData object to hold form data

      const itemsToAdd = []; // Array to store items to be added to the cart

      // Iterate over the form data to extract products with a quantity greater than 0
      formData.forEach((value, key) => {
        if (key.startsWith("quantity_") && value > 0) {
          const productId = key.split("_")[1];
          const variantId = formData.get("variant_" + productId);
          const quantity = value;

          // Add each valid item to the itemsToAdd array
          itemsToAdd.push({
            id: variantId,
            quantity: quantity,
          });
        }
      });

      // Function to add a single item to the cart via an API call
      function addItemToCart(item) {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            quantity: item.quantity,
            id: item.id,
          }),
        });
      }

      // Function to add all items to the cart sequentially
      function addAllItemsToCart(items) {
        let sequence = Promise.resolve();

        items.forEach((item) => {
          sequence = sequence.then(() => addItemToCart(item));
        });

        return sequence;
      }

      // Add all items to the cart and then redirect to the cart page
      addAllItemsToCart(itemsToAdd).then(() => {
        window.location.href = "/cart";
      });
    });

  // Get all the subtract and add buttons
  const subtractButtons = document.querySelectorAll(".subtract-button");
  const addButtons = document.querySelectorAll(".add-button");

  // Add event listeners to the subtract buttons to decrease the quantity
  subtractButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.nextElementSibling; // Select the input next to this button
      let value = parseInt(input.value) || 0;
      if (value > parseInt(input.min)) {
        input.value = value - 1; // Decrease the value by 1
        input.dispatchEvent(new Event("input")); // Trigger the input event
        updateTotalPrice(); // Update the total price after decreasing the value
      }
    });
  });

  // Add event listeners to the add buttons to increase the quantity
  addButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.previousElementSibling; // Select the input before this button
      let value = parseInt(input.value) || 0;
      if (value < parseInt(input.max)) {
        input.value = value + 1; // Increase the value by 1
        input.dispatchEvent(new Event("input")); // Trigger the input event
        updateTotalPrice(); // Update the total price after increasing the value
      }
    });
  });

  const expandSummaryButton = document.querySelector(".expand-summary-button");
  const expandSummaryArrow = document.querySelector(".expand-summary-arrow");
  const summary = document.querySelector(".summary-content");

  function displayExpandButton() {
    if (window.innerWidth < 1024) {
      summary.classList.remove("active");
      expandSummaryButton.classList.add("active");
    } else {
      summary.classList.add("active");
      expandSummaryButton.classList.remove("active");
    }
  }

  displayExpandButton();

  window.addEventListener("resize", displayExpandButton);

  expandSummaryButton.addEventListener("click", () => {
    summary.classList.toggle("active");
    expandSummaryArrow.classList.toggle("rotate");
  });

  const tabButtonContainer = document.querySelector(".tab-button-container");

  function isTabButtonContainerAtTheTop() {
    const tabWatcher = tabButtonContainer.getBoundingClientRect().top;
    if (tabWatcher <= 0) {
      tabButtonContainer.classList.add("isAtTop");
    } else {
      tabButtonContainer.classList.remove("isAtTop");
    }
  }

  window.addEventListener("scroll", isTabButtonContainerAtTheTop);
});
